"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscribeButton = void 0;
var _openSubscriptionWizard = _interopRequireDefault(require("@ori-events/open-subscription-wizard"));
var _components = require("@ori-ui/components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _internal = require("../../hooks/internal");
var _useTranslations = require("../../hooks/useTranslations");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const SubscribeButton = ({
  isPrimary = true
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const {
    currentShade: {
      productCode
    }
  } = (0, _internal.useProduct)();
  const onClick = (0, _react.useCallback)(() => {
    _openSubscriptionWizard.default.dispatch({
      detail: {
        type: 'Subscription',
        customerType: 'All',
        productCode
      }
    });
  }, [productCode]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
    fullWidth: true,
    color: isPrimary ? 'primary' : 'default',
    variant: isPrimary ? 'contained' : 'outlined',
    "data-testid": getTestId(_constants.SUBSCRIBE_BUTTON),
    onClick: onClick,
    children: translations.subscribe
  });
};
exports.SubscribeButton = SubscribeButton;